"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWrapper = exports.StyledCard = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Card = _interopRequireDefault(require("../Card"));

var _card = require("../../../../styles/2_commonComponentStyles/card");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCard = (0, _styledComponents.default)(_Card.default).withConfig({
  displayName: "ContentCardstyles__StyledCard",
  componentId: "sc-1yrplyz-0"
})(["", ";padding:", ";"], _card.responsiveCard, function (props) {
  return props.theme.standardPadding;
});
exports.StyledCard = StyledCard;

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "ContentCardstyles__ContentWrapper",
  componentId: "sc-1yrplyz-1"
})(["& >:first-child{padding-top:0;}& >:last-child{padding-bottom:0;}"]);

exports.ContentWrapper = ContentWrapper;